import factoryLogger from '../../logger/index.js'
import PageServicesFactory from '../../page/Services/factory.js'
import {SearchServicesFactory} from '../../search/Services/factory.js'
import {SearchValueObjectsFactory} from '../../search/ValueObjects/factory.js'
import UserServicesFactory from '../../user/Services/factory.js'
import AdsEntitiesFactory from '../Entities/factory.js'
import AdsMappersFactory from '../Mappers/factory.js'
import AdsRepositoriesFactory from '../Repositories/factory.js'
import {GetAdDetailsAdsService} from './GetAdDetailsAdsService.js'
import GetAlertSearchAdsService from './GetAlertSearchAdsService.js'
import {GetFinancingDataAdsService} from './GetFinancingDataAdsService.js'
import GetHomeAdsService from './GetHomeAdsService.js'
import GetRelatedAdsService from './GetRelatedAdsService.js'
import {GetRelatedSubscriptionAdsService} from './GetRelatedSubscriptionAdsService.js'
import {GetSearchPaginationUrlAdsService} from './GetSearchPaginationUrlAdsService.js'
import GetSearchResultsAdsService from './GetSearchResultsAdsService.js'
import GetSearchUrlAdsService from './GetSearchUrlAdsService.js'
import {GetSubscriptionCommitmentOptionsAdsService} from './GetSubscriptionCommitmentOptionsAdsService.js'
import {GetSubscriptionSearchResultsAdsService} from './GetSubscriptionSearchResultsAdsService.js'
import {SaveNavigationDataAdsService} from './SaveNavigationDataAdsService.js'

export default class AdsServicesFactory {
  /**
   * @method
   * @param {Object} deps
   * @param {Config} deps.config
   * @return {GetHomeAdsService}
   * @property {HTTPAdsRepository} repository
   */
  static getHomeAdsService = ({config}) =>
    new GetHomeAdsService({
      repository: AdsRepositoriesFactory.httpAdsRepository({config})
    })

  /**
   * @method
   * @param {Object} deps
   * @param {Config} deps.config
   * @return {GetAdDetailsAdsService}
   */
  static getAdDetailsAdsService = ({config}) =>
    new GetAdDetailsAdsService({
      config,
      log: factoryLogger({prefix: 'GetAdDetailsAdsService'}),
      repository: AdsRepositoriesFactory.httpAdsRepository({config}),
      getCurrentUserService: UserServicesFactory.getCurrentUserService({
        config
      })
    })

  /**
   * @method
   * @param {Object} deps
   * @param {Config} deps.config
   * @return {GetRelatedAdsService}
   * @property {HTTPAdsRepository} repository
   */
  static getRelatedAdsService = ({config}) =>
    new GetRelatedAdsService({
      config,
      repository: AdsRepositoriesFactory.httpAdsRepository({config})
    })

  /**
   * @method
   * @param {Object} deps
   * @param {Config} deps.config
   * @return {GetRelatedAdsService}
   * @property {HTTPAdsRepository} repository
   */
  static getRelatedSubscriptionAdsService = ({config}) =>
    new GetRelatedSubscriptionAdsService({
      repository: AdsRepositoriesFactory.httpAdsRepository({config})
    })

  static getSearchPaginationUrlAdsService = ({config}) =>
    new GetSearchPaginationUrlAdsService({
      config,
      fromSearchJSONToUrlVOMapper: AdsMappersFactory.fromSearchJSONToUrlVOMapper({config}),
      getUrlService: PageServicesFactory.getUrlService({config})
    })

  /**
   * @method
   * @param {Object} deps
   * @param {Config} deps.config
   * @return {GetSearchUrlAdsService}
   */
  static getSearchUrlAdsService = ({config}) =>
    new GetSearchUrlAdsService({
      config,
      searchRequestValueObjectFactory: SearchValueObjectsFactory.searchRequestValueObject,
      mapper: AdsMappersFactory.fromSearchJSONToUrlVOMapper({config}),
      getUrlService: PageServicesFactory.getUrlService({config})
    })

  /**
   * @method
   * @param {Object} deps
   * @param {Config} deps.config
   * @return {getSearchResultsAdsService}
   */
  static getSearchResultsAdsService = ({config}) =>
    new GetSearchResultsAdsService({
      config,
      repository: AdsRepositoriesFactory.httpAdsRepository({config}),
      searchRequestValueObjectFactory: SearchValueObjectsFactory.searchRequestValueObject
    })

  /**
   * @method
   * @param {Object} deps
   * @param {Config} deps.config
   * @return {GetSubscriptionSearchResultsAdsService}
   */
  static getSubscriptionSearchResultsAdsService = ({config}) =>
    new GetSubscriptionSearchResultsAdsService({
      httpAdsRepository: AdsRepositoriesFactory.httpAdsRepository({config})
    })

  /**
   * @method
   * @param {Object} deps
   * @param {Config} deps.config
   * @return {GetSubscriptionCommitmentOptionsAdsService}
   */
  static getSubscriptionCommitmentOptionsAdsService = ({config}) =>
    new GetSubscriptionCommitmentOptionsAdsService({
      httpAdsRepository: AdsRepositoriesFactory.httpAdsRepository({config})
    })

  /**
   * @method
   * @param {Object} deps
   * @param {Config} deps.config
   * @param {Config} deps.adEntityToAdsSearchParamsVOMapper
   * @return {SearchRequestValueObject}
   */
  static getAlertSearchAdsService = ({config}) =>
    new GetAlertSearchAdsService({
      config,
      adEntityFactory: AdsEntitiesFactory.adEntity,
      adEntityToAdSearchParamsVOMapper: AdsMappersFactory.adEntityToAdSearchParamsVOMapper({config})
    })

  /**
   * @method
   * @param {Object} deps
   * @param {Config} deps.config
   * @param {Service} deps.saveNavigationDataSearchService
   * @return {SaveNavigationDataAdsService}
   */
  static saveNavigationDataAdsService = ({config}) =>
    new SaveNavigationDataAdsService({
      config,
      saveNavigationDataSearchService: SearchServicesFactory.saveNavigationDataSearchService({
        config
      })
    })

  /**
   * @method
   * @param {Object} deps
   * @return {GetFinancingDataAdsService}
   */
  static getFinancingDataAdsService = ({config}) =>
    new GetFinancingDataAdsService({
      repository: AdsRepositoriesFactory.httpAdsRepository({config})
    })
}
